/**
 * @description pics model
 * @date 2019-05-07
 * @author jywang
 */
import React, { PureComponent } from 'react';
import { Pagination } from 'antd';
import { UnitLi } from './component/unit-li';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react/custom';
import moment from 'moment';
import toast from '@util/toast';
import tool from '@util/tool';
import StatusTab from '../../components/StatusTab';
import './index.scss';

@inject('store')
@observer
class PicsList extends React.Component<any, any> {
    public tabList =  [
        { status: null, text: '全部'},
         { status: 1, text: '审核中' },
         { status: 2, text: '已发布' },
         { status: 3, text: '审核未通过' },
         { status: 5, text: '定时发布中' }
     ];
    public tabListMap = {
        1: '审核中',
        2: '已发布',
        3: '审核未通过',
        5: '定时发布中'
    };

    public iframeAddr: string;
    public constructor(props) {
        super(props);
    }
    public componentWillMount() {
        this.props.store.hasLoginManage();
        this.getPicsList();

        const Env = window['serverEnv'] || window['localEnv'];
        switch (Env) {
            case 'dev':
                this.iframeAddr = 'http://www-dev.lixiang.com';
                break;
            case 'test':
                this.iframeAddr = 'https://www-test.lixiang.com';
                break;
            case 'ontest':
                this.iframeAddr = 'https://www-ontest.lixiang.com';
                break;
            case 'prod':
                this.iframeAddr = 'https://www.lixiang.com';
                break;
            default:
                toast.error('缺少iframe环境变量');
                break;
        }
    }
    public tabChange = (e) => {
        const info: any = {};
        info.status = e;
        this.getPicsList(info);
    }
    public render() {
        const { store } = this.props;
        const { editPicsList } = store;
        return (
            <div className="pics-list-box">
                <StatusTab onChange={this.tabChange}  tabList={this.tabList}></StatusTab>
                <div className="pics-list-box">
                    <ul hidden={editPicsList.results.length <= 0}>
                        {editPicsList.results.length > 0 &&
                            editPicsList.results.map((item, idx) => {
                                const {name: groupName= ''} = item.group || {};
                                return (
                                    <li key={idx}>
                                        <UnitLi
                                            clickJump={`${this.iframeAddr}/app/club/article/${item.id}.html?cms=true&webEditorial=true`}
                                            delVideo={this.delPics}
                                            editCall={() => this.editPics(item)}
                                            imageUrls={item.images}
                                            surfacePlot={item.surfacePlot}
                                            title={item.title}
                                            browseSum={item.browseSum}
                                            favourSum={item.favourSum}
                                            commentSum={item.commentSum}
                                            collectSum={item.collectSum}
                                            groupName={groupName}
                                            releaseTime={moment(
                                                item.releaseTime
                                            ).format('YYYY-MM-DD HH:mm:ss')}
                                            statusName={this.tabListMap[item.status]}
                                            id={item.id}
                                            item={item}
                                        />
                                    </li>
                                );
                            })}
                    </ul>
                    <p
                        hidden={
                            editPicsList.dataStatus !== 'done' ||
                            (editPicsList.dataStatus === 'done' &&
                                editPicsList.results &&
                                editPicsList.results.length > 0)
                        }
                        className="no-data">
                        暂无数据
                    </p>
                    <p
                        hidden={editPicsList.dataStatus !== 'pending'}
                        className="no-data">
                        加载数据中...
                    </p>
                </div>
                <div className="page-box">
                    <Pagination
                        size="small"
                        onShowSizeChange={this.onShowSizeChange}
                        onChange={this.pageChange}
                        defaultCurrent={1}
                        defaultPageSize={editPicsList.pageSize}
                        total={editPicsList.totalCount}
                        showSizeChanger={true}
                        showQuickJumper={true}
                    />
                </div>
            </div>
        );
    }
    public pageChange = (current, size) => {
        console.log(current, size);
        const info: any = {};
        info.pageNo = current;
        info.pageSize = size;
        this.getPicsList(info);
    };
    public onShowSizeChange = (current, size) => {
        console.log(current, size);
        const info: any = {};
        info.pageNo = current;
        info.pageSize = size;
        this.getPicsList(info);
    };
    public getPicsList = (param?) => {
        let info: any = {};
        info.pageNo = 1;
        info.pageSize = 10;
        info = Object.assign(info, param);
        this.props.store.editPicsList.get(info);
    };
    public delPics = (id) => {
        this.props.store.picsList
            .del(id)
            .then(() => {
                toast.error('删除成功');
                this.getPicsList();
            })
            .catch((err) => {
                toast.error('删除失败');
            });
    };
    public editPics = (item) => {
        const {groupId} = item.group || {};
        location.href = tool.getToDetailHref('/edit-pics/create', {id: item.id, groupId});
    };
}
export default PicsList;
